export default __webpack_public_path__ + "static/media/icon3.eeae0a3d.jpg";